import { FormattedCurrency } from '../../../iwIntlProvider/FormattedCurrency';

export const MoneyNoDecimals = (props) => {
    const { className, value } = props;

    return (
        <FormattedCurrency
            className={className}
            decimalPlaces={0}
            value={value}
        />
    );
};
